import { z } from 'zod'

export const accountTypeSchema = z.enum(['AHORRO', 'CORRIENTE'])
export const genderSchema = z.enum(['MASCULINO', 'FEMENINO'])
export const maritalStatusSchema = z.enum([
  'SOLTERO',
  'CASADO',
  'DIVORCIADO',
  'VIUDO'
])
export const occupationSchema = z.enum([
  'Estudiante',
  'Trabajador independiente',
  'Profesional especialista (Médico, Abogado entre otros )',
  'Empleado de sector público',
  'Efectivos de fuerzas armadas o seguridad',
  'Otros'
])
